/* src/app/home-new/binding-options/binding-options.component.scss */
.color-button {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  margin: 0 4px;
  border: 4px solid white;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.color-button.selected {
  border: 4px solid #ffcd00;
}
.color-button:hover {
  cursor: pointer;
}
.color-button.transparent {
  background:
    repeating-linear-gradient(
      -45deg,
      white,
      white 4px,
      rgba(0, 0, 0, 0.1) 4px,
      rgba(0, 0, 0, 0.1) 9px);
}
.title {
  font-size: 14px;
  font-weight: 600;
}
.note {
  width: 100%;
  font-weight: lighter;
  font-size: 12px;
  color: gray;
  text-align: center;
  font-style: italic;
  margin-bottom: 5px;
}
.custom-segment-button {
  --indicator-color: var(--ion-color-primary) !important;
}
.custom-segment-button ion-label {
  line-height: 16px !important;
}
.exclusive-title {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 10px;
}
.soldOut {
  opacity: 0.3;
}
ion-segment {
  background: #f4f4f4;
  border-radius: 15px;
  padding: 8px;
  margin-bottom: 5px;
}
ion-segment.finishing-selected {
  margin-bottom: 0px;
  border-bottom: 0px;
  background-color: #fff;
}
ion-segment ion-segment-button {
  padding: 5px 0;
}
ion-segment ion-segment-button::part(indicator-background) {
  border-radius: 8px;
  background: rgba(67, 192, 246, 0.0509803922);
}
ion-segment ion-segment-button.segment-button-checked ion-label {
  color: var(--ion-color-primary);
}
ion-segment ion-label {
  font-size: 16px;
}
.segment-selection {
  text-align: center;
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 600;
}
img,
svg {
  width: 38px;
  height: 51px;
}
.selection {
  padding: 0px;
  cursor: pointer;
}
.selection.selected {
  border-radius: 10px;
  pointer-events: none;
}
.categoryTitle {
  color: #000;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 12px;
  margin-bottom: 15px;
  text-align: start;
}
.laminations.finishing-selected {
  border: 1 solid #949494;
  border-radius: 15px;
  border-top: 0px;
  padding: 10px;
  background-color: #fff;
}
.finishing-selected {
  background-color: transparent;
  color: #949494;
  border: 1px solid #949494;
}
.finishing-selected .selection {
  padding: 2px;
  border: 2px solid white;
  border-radius: 10px;
}
.finishing-selected .selection.selected {
  border: 2px solid #f5b200;
  box-shadow: 0px 0px 15px 0px rgba(245, 178, 0, 0.8);
}
.finishing-selected .selection.zoom:hover {
  transform: scale(1.5);
  transition: transform 0.2s ease-in-out;
}
.finishing-selected .bubble {
  padding: 3px 9px;
  border-radius: 16px;
  background: #f6f5f5;
}
.finishing-selected .image-container {
  padding: 2px;
  background-color: white;
  border-radius: 5px;
  display: block;
}
.finishing-selected .image-container img {
  display: block;
  height: auto;
}
.finishing-selected ion-segment-button::part(indicator-background) {
  background: rgba(245, 178, 0, 0.3019607843) !important;
}
.finishing-selected ion-segment-button.segment-button-checked ion-label {
  color: #000 !important;
}
.finishing-selected h3 {
  color: #949494;
}
.finishing-selected .segment-selection {
  color: #d59b00;
}
/*# sourceMappingURL=binding-options.component-HVTQUBH2.css.map */
